
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-home-4-line',
      title: 'New Construction',
      description: 'Complete residential and commercial new builds from foundation to finish. We bring your vision to life with precision and quality craftsmanship.',
      image: 'https://public.readdy.ai/ai/img_res/9046c147889c5038f948881e66229803.jpg'
    },
    {
      icon: 'ri-tools-line',
      title: 'Remodeling',
      description: 'Transform your existing space with expert remodeling services. Kitchen, bathroom, basement, or whole-home renovations done right.',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20modern%20kitchen%20remodeling%20project%20with%20white%20cabinets%2C%20granite%20countertops%2C%20stainless%20appliances%2C%20professional%20renovation%20work%2C%20bright%20natural%20light%2C%20simple%20clean%20background%2C%20interior%20design%20photography%2C%20high%20quality&width=600&height=400&seq=service-remodeling-1&orientation=landscape'
    },
    {
      icon: 'ri-hammer-line',
      title: 'Custom Carpentry',
      description: 'Skilled custom carpentry for unique woodwork, built-ins, trim, cabinetry, and specialty projects tailored to your specifications.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20custom%20carpentry%20work%20showing%20detailed%20woodworking%2C%20built-in%20cabinets%2C%20trim%20work%2C%20craftsmanship%20details%2C%20natural%20wood%20finish%2C%20simple%20clean%20background%2C%20professional%20photography%2C%20high%20resolution&width=600&height=400&seq=service-carpentry-1&orientation=landscape'
    },
    {
      icon: 'ri-home-gear-line',
      title: 'Roofing Services',
      description: 'Professional roofing installation, repair, and replacement. Protecting your investment with durable, weather-resistant solutions.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20roofing%20installation%20on%20residential%20home%2C%20new%20shingles%2C%20roofing%20crew%20working%2C%20quality%20craftsmanship%2C%20blue%20sky%2C%20simple%20clean%20background%2C%20construction%20photography%2C%20high%20quality%2C%20sharp%20focus&width=600&height=400&seq=service-roofing-1&orientation=landscape'
    },
    {
      icon: 'ri-layout-line',
      title: 'Decks and Siding',
      description: 'Beautiful outdoor decks and quality siding installation that enhance curb appeal and add value to your property.',
      image: 'https://readdy.ai/api/search-image?query=Beautiful%20wooden%20deck%20construction%20with%20railings%2C%20outdoor%20living%20space%2C%20professional%20carpentry%2C%20natural%20wood%20finish%2C%20backyard%20setting%2C%20simple%20clean%20background%2C%20architectural%20photography%2C%20high%20resolution&width=600&height=400&seq=service-decks-1&orientation=landscape'
    },
    {
      icon: 'ri-paint-brush-line',
      title: 'Flooring and Painting',
      description: 'Expert flooring installation and professional painting services for interior and exterior projects of any size.',
      image: 'https://readdy.ai/api/search-image?query=Professional%20interior%20painting%20and%20hardwood%20flooring%20installation%2C%20modern%20room%20with%20fresh%20paint%2C%20beautiful%20wood%20floors%2C%20clean%20finish%2C%20simple%20clean%20background%2C%20interior%20design%20photography%2C%20high%20quality&width=600&height=400&seq=service-flooring-1&orientation=landscape'
    }
  ];

  return (
    <section id="services" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Our <strong>Construction Services</strong>
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Comprehensive residential and commercial construction solutions. No project is too big or too small for our experienced team.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service, index) => (
            <div 
              key={index} 
              className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 cursor-pointer"
              data-product-shop
            >
              <div className="h-48 overflow-hidden">
                <img 
                  src={service.image} 
                  alt={service.title}
                  title={`${service.title} - DDR Construction Solutions`}
                  className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-5 sm:p-6">
                <div className="w-12 h-12 sm:w-14 sm:h-14 bg-red-100 rounded-lg flex items-center justify-center mb-3 sm:mb-4">
                  <i className={`${service.icon} text-2xl sm:text-3xl text-red-600 w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center`}></i>
                </div>
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">{service.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{service.description}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-8 sm:mt-12">
          <a 
            href="/contact" 
            className="inline-block bg-red-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-lg hover:bg-red-700 transition-colors font-semibold text-base sm:text-lg whitespace-nowrap cursor-pointer"
          >
            Request a Quote
          </a>
        </div>
      </div>
    </section>
  );
}
